var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgScheduleMessageContentIcon = function SvgScheduleMessageContentIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "#ECF1F3",
    rx: 15.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A657B",
    fillRule: "nonzero",
    d: "M22.349 8c.974 0 1.794.799 1.794 1.797v8.122c0 .976-.797 1.797-1.794 1.797h-3.367v2.84c0 .178-.11.333-.265.4-.067.022-.111.044-.178.044-.11 0-.221-.044-.31-.133l-3.167-3.173H8.794c-.975 0-1.794-.799-1.794-1.798V9.797C7 8.821 7.797 8 8.794 8h13.555zm-.022.888H8.794c-.487 0-.908.399-.908.91v8.12c0 .489.399.91.908.91h6.445c.11 0 .222.045.31.134l2.525 2.53v-2.22c0-.244.2-.444.443-.444h3.81c.487 0 .908-.399.908-.91v-8.12c0-.489-.399-.91-.908-.91zM14.625 15.5c.226 0 .41.241.41.536 0 .294-.184.535-.41.535H10.09c-.226 0-.41-.24-.41-.535 0-.295.184-.536.41-.536h4.536zm6.39-2.143c.247 0 .45.241.45.536 0 .294-.203.536-.45.536H10.127c-.247 0-.45-.242-.45-.536 0-.295.203-.536.45-.536h10.886zm0-2.143c.247 0 .45.241.45.536 0 .295-.203.536-.45.536H10.127c-.247 0-.45-.241-.45-.536 0-.295.203-.536.45-.536h10.886z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgScheduleMessageContentIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/schedule-message-content-icon.60b0212d56383280806083611b836cc4.svg";